import { getAtarText } from "/src/helper/atar.js";

document.addEventListener("alpine:init", () => {
  Alpine.store("atarCalculator", {
    adjustedATAR: 99.95,
    estimateAdjustedATAR: 99.95, // intended unpersisted
    fourSubjectsSelected: false,
    adjustmentPoints: 0,
    getAdjustedAtarText() {
      return getAtarText(this.adjustedATAR);
    },
    getEstimateAdjustedAtarText() {
      return getAtarText(this.estimateAdjustedATAR);
    },
  });

  Alpine.data("atarCalculatorPersistProxy", function () {
    return {
      adjustedATAR: this.$customPersist(99.95).as("atarJourney_adjustedATAR"),
      fourSubjectsSelected: this.$customPersist(false).as(
        "atarJourney_fourSubjectsSelected"
      ),
      adjustmentPoints: this.$customPersist(0).as(
        "atarJourney_adjustmentPoints"
      ),

      init() {
        ["adjustedATAR", "fourSubjectsSelected", "adjustmentPoints"].forEach(
          (attrName, i) => {
            // setting default value
            this.$store.atarCalculator[attrName] = this[attrName];

            // listen future value change and set and persistt value
            this.$nextTick(() => {
              this.$watch(`$store.atarCalculator.${attrName}`, (newVal) => {
                this[attrName] = newVal;
              });
            });
          }
        );
      },
    };
  });
});

(() => {
  // add a proxy element to DOM
  const div = document.createElement("div");
  div.setAttribute("x-data", "atarCalculatorPersistProxy");
  div.setAttribute("style", "display: none");
  document.body.appendChild(div);
})();
